<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品材质</el-breadcrumb-item>
    </el-breadcrumb>    
    <el-card>
      <!-- 添加材质 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            placeholder="请输入搜索内容"
            v-model="queryInfo.query"
            @clear="getList">
            <el-button
              slot="append"
              @click="getList"
              icon="el-icon-search">
            </el-button>
          </el-input>
        </el-col>
      </el-row> 
      <!-- 表格 -->
      <el-row>
        <el-table :data="tableData" border stripe>
          <el-table-column 
            type="index" 
            align="center" 
            size="mini" 
            width="50">
          </el-table-column>
          <el-table-column
            align="center"
            v-for="(item, index) in userCloumn"
            :key="index"
            size="mini"
            :prop="item.name"
            :min-width="item.minWidth"
            :label="item.label">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="220px"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="showEditDialog(scope.row)"
                size="mini">
                添加备注
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="removeUser(scope.row.id)"
                size="mini">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>  
      <!-- 页码 -->
      <el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[15,50]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>      
      </el-row>   
    </el-card>

    <!-- 添加/编辑 材质 -->
    <el-dialog
      title="添加备注"
      :visible.sync="userDialog"
      width="38%"
      @close="userDialogClosed">
      <el-form
       :model="userForm"
       :rules="userFormRules"
       ref="userFormRef"
       label-width="90px">
        <el-form-item label="备注信息">
          <el-input size="small" v-model="userForm.username"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="userDialog = false" size="small">取消</el-button>
        <el-button  type="primary" @click="editUser" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/mixins/tables'
export default {
  data () {
    var checkMobile = (rule, val , cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        if (regMobile.test(val)) {
          return cb()
        } else {
          cb(new Error('请输入合法手机号'))
        }
    }
    return {
      userTitle:'添加',
      userDialog: false,
      userForm: {
        userid:0,
        username: '',
        mobile: '',
        sex: '',
        plote:'',
        remork:'',
      },
      userFormRules: {
        username: [
          { required: true, message: '请选择材质名称', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        sex:[
          { required: true, message: '请选择性别', trigger: 'blur' },
        ],
        plote:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ]
      },  
      sexOptions: [{
          value: 0,
          label: '男'
        }, {
          value: 1,
          label: '女'
        }],
      typeOptions: [{
          value: 0,
          label: '区域管理员'
        }, {
          value: 1,
          label: '系统管理员'
        }],
      tableData: [ ],
      userCloumn: [
        { name: 'name', label: '名称', minWidth: '160px' } ,
        { name: 'mobile', label: '联系电话', minWidth: '160px' } ,
        { name: 'time_at', label: '时间', minWidth: '160px' }  ,
        { name: 'content', label: '备注', minWidth: '160px' }    
      ],  
    }
  },
  mixins: [table],
  created () {
    this.queryInfo.pagesize = 15
    this.getList()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/product/contactList',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              var newList = [];
              for(var i=0;i<data.list.length;i++){
                newList.push({
                  id:data.list[i].id,
                  name:data.list[i].name,
                  mobile:data.list[i].mobile,
                  time_at:data.list[i].time_at,
                  content:data.list[i].content
                })
              }
              that.tableData = newList;
              that.total = data.totalCount;
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },
    showAddDialog() {
      this.userDialog = true
      this.userTitle = '添加'
    },
    userDialogClosed() {
      this.$refs.userFormRef.resetFields()
      this.userForm.username = ""
      this.userForm.userid = ""
    },
    addUserBtn() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/addCaizhi',{
              username:this.userForm.username,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('材质添加成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    showEditDialog(row) {
      console.log('显示编辑材质');
      this.userDialog = true
      this.userTitle = '编辑'
      this.userForm.username = row.content
      this.userForm.userid = row.id
    },
    editUser() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/editContent',{
              userid:this.userForm.userid,
              username:this.userForm.username,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('备注信息修改成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    removeUser(id) {
      var that = this;
      const confirmResult = this.$confirm(
        '是否删除联系人信息？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'          
        }
      ).then(async () => { //  不要忘记加 async
              window.console.log(1);
              that.$post('/apis/manage/product/delContact',{
                userid:id,
                token:sessionStorage.getItem('token'),
              }).then(function(res){
                if(res.errno == 0){
                  that.$message.success('联系人删除成功');
                  that.getList();
                }else{
                  that.$message.info(res.errmsg);
                }
              }).catch(function(err){
                
                window.console.log(2);
              });
            
        }).catch(err => err)
    }
  }
}
</script>
